import { useState } from 'react';
import apiService from '../../axios/apiService';

export const useGetInvoiceFooter = () => {
  const [data, setData] = useState(undefined);
  const [loading, setLoading] = useState(false);
  const getData = async () => {
    // Fetch invoice footer
    setLoading(true);
    try {
      const response = await apiService.getInvoiceFooter();
      response && setData(response); // update data state
      return response;
    } finally {
      setLoading(false);
    }
  };

  return {
    data,
    loading,
    getData,
  };
};
